// @ts-check

import { createSlice } from '@reduxjs/toolkit';

/** @type {UserInfoTypeObj} */
const initialState = {
	userInfo: {
		contactId: '',
		userId: '',
		employeeId: '',
		username: '',
		fullname: '',
		firstName: '',
		lastName: '',
		customerId: '',
		vFile: '',
		image: '',
		postLoginURL: '',
		userRoleGroups: [],
		roles: [],
	},
};

/**
 * @type {Object} userInfoSlice
 * @property {string} name
 * @property {UserInfoType} initialState
 * @property {Object} reducers
 * @property {function} reducers.storeUserInfo
 */
const userInfoSlice = createSlice({
	name: 'userInfo',
	initialState,
	reducers: {
		storeUserInfo: (state, action) => {
			state.userInfo = action.payload;
		},
		storeUserInfoImage: (state, action) => {
			state.userInfo.vFile = action.payload.vFile;
			state.userInfo.image = action.payload.image;
		},
	},
});

/**
 * @function
 * @desc Selector function to get the user information from the state.
 * @param {Object} state
 * @returns {UserInfoTypeObj}
 */
export const selectUserInfo = (state) => {
	const userInfo = state.userInfo;
	return userInfo;
};

export const { storeUserInfo, storeUserInfoImage } = userInfoSlice.actions;

export default userInfoSlice.reducer;
